import {Button} from "@reside/ui";

import {useFacilitySettingsParams} from "../../../hooks/useFacilitySettingsParams";
import {
  toApi,
  getArbitrationPdfUrl,
  withAccessToken,
} from "../../../../../utils/url";
import {useTemplateHasArbitrationDocumentQuery} from "../../../../../models/pcc";
import {hasArbitrationDocument} from "../../../../../services/AdmissionsService";

type DownloadArbitrationPDFButtonProps = {
  facilityTemplate: string;
  type: "empty" | "in-progress";
  admissionId?: string;
  templateDocumentTypes?: ReadonlyArray<string>;
};

export const DownloadArbitrationPDFButton = ({
  facilityTemplate,
  type,
  admissionId,
  templateDocumentTypes,
}: DownloadArbitrationPDFButtonProps): JSX.Element => {
  const {facilityId} = useFacilitySettingsParams();

  // For empty templates, check if template has arbitration documents
  const {data: templateData, isLoading: isLoadingTemplate} =
    useTemplateHasArbitrationDocumentQuery(facilityId, facilityTemplate, {
      enabled: type === "empty" && !!facilityId && !!facilityTemplate,
    });

  // For empty template: Only show if hasArbitrationDocument is explicitly true
  // Hide while loading or if hasArbitrationDocument is false/undefined
  // For in-progress: Check using the admission's templateDocumentTypes
  const shouldShow =
    (type === "empty" &&
      !isLoadingTemplate &&
      templateData?.hasArbitrationDocument === true) ||
    (type === "in-progress" && hasArbitrationDocument(templateDocumentTypes));

  const handleDownload = () => {
    let url: string;

    if (type === "empty") {
      url = withAccessToken(
        toApi(
          `v3/documents/template/${facilityId}/${facilityTemplate}/arbitration-pdf/latest`,
        ),
      );
    } else if (type === "in-progress" && admissionId) {
      url = getArbitrationPdfUrl(admissionId);
    } else {
      return;
    }

    window.open(url, "_blank");
  };

  if (!shouldShow) {
    return null;
  }

  return (
    <Button color="primary" outline onClick={handleDownload}>
      Download Arbitration Agreement
    </Button>
  );
};
